/// <reference types="vite/client" />
/// <reference types="vite/types/importMeta.d.ts" />

interface EnvConfig {
  APP_ENVIRONMENT: string;

  API_BASE_URL: string;
  OIDC_AUTHORITY: string;
  OIDC_CLIENT_ID: string;
  OIDC_REDIRECT_URI: string;

  SENTRY_DSN: string;
  SENTRY_AUTH_TOKEN: string;

  MAPBOX_ACCESS_TOKEN: string;
}

function readEnvVariable(key: keyof EnvConfig): string {
  const value = import.meta.env[`VITE_${key}`];

  if (!value) {
    throw new Error(`Environment variable "${key}" is missing`);
  }

  return value;
}

export const config: EnvConfig = {
  APP_ENVIRONMENT: readEnvVariable("APP_ENVIRONMENT"),
  API_BASE_URL: readEnvVariable("API_BASE_URL"),
  OIDC_AUTHORITY: readEnvVariable("OIDC_AUTHORITY"),
  OIDC_CLIENT_ID: readEnvVariable("OIDC_CLIENT_ID"),
  OIDC_REDIRECT_URI: readEnvVariable("OIDC_REDIRECT_URI"),
  SENTRY_DSN: readEnvVariable("SENTRY_DSN"),
  SENTRY_AUTH_TOKEN: readEnvVariable("SENTRY_AUTH_TOKEN"),
  MAPBOX_ACCESS_TOKEN: readEnvVariable("MAPBOX_ACCESS_TOKEN"),
};

export const isDevelopment = config.APP_ENVIRONMENT === "development";
